import request from "@utils/request";

export function getDailyWinner(query) {
    return request({
        url: 'alert/data/daily-winner',
        method: 'get',
        params: query
    })
}
